var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-form",
    {
      ref: "form",
      staticClass: "yxtbiz-kng-operator__form pl15",
      class: _vm.error ? "yxtbiz-kng-operator__form--error" : "",
      attrs: {
        model: _vm.info,
        "label-position": "top",
        size: "small",
        "label-width": "150px",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "yxtbiz-kng-operator__form-title",
          attrs: { id: "info_1" },
        },
        [_vm._v(_vm._s(_vm.$t("pc_kng_kngcourse_menu_basic" /** 基本信息 */)))]
      ),
      _vm.info.serverGroupId
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "pc_kng_courseware_lbl_mediaservergroup" /**媒体服务器组 */
                ),
                "label-width": "150px",
                prop: "serverGroupId",
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.info.serverGroupName) + "\n  ")]
          )
        : _vm._e(),
      _vm.getItemShow("link")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_kng_courseware_lbl_newlink" /**课件链接 */),
                prop: "indexPath",
                rules: _vm.getItemRules("link"),
              },
            },
            [
              _c("yxt-input", {
                attrs: {
                  maxlength: "500",
                  "show-word-limit": "",
                  autofocus: "",
                  clearable: "",
                  disabled: _vm.getItemDisabled("link"),
                  placeholder: _vm.$t(
                    "pc_kng_upload_tip_newlink_input" /**请输入课件网址，建议使用https格式的网址，http网址不支持在iPhone手机中播放 */
                  ),
                },
                model: {
                  value: _vm.info.indexPath,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "indexPath", $$v)
                  },
                  expression: "info.indexPath",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.NAME)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_name" /**名称 */),
                prop: "title",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.NAME),
              },
            },
            [
              _c("yxt-input", {
                attrs: {
                  "show-word-limit": "",
                  maxlength: "200",
                  disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.NAME),
                },
                model: {
                  value: _vm.info.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "title", $$v)
                  },
                  expression: "info.title",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.CATAlOG)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_kng_kngcourse_lbl_catlog" /**分类 */),
                prop: "catalogId",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.CATAlOG),
              },
            },
            [
              _c("form-catalog", {
                attrs: {
                  id: _vm.info.catalogId,
                  name: _vm.info.catalogName,
                  disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.CATAlOG),
                  info: _vm.info,
                },
                on: {
                  "update:id": function ($event) {
                    return _vm.$set(_vm.info, "catalogId", $event)
                  },
                  "update:name": function ($event) {
                    return _vm.$set(_vm.info, "catalogName", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("point")
        ? _c(
            "yxt-form-item",
            [
              _c(
                "div",
                {
                  staticClass:
                    "yxtbiz-flex-center yxtbiz-kng-operator__form-points",
                  attrs: { slot: "label" },
                  slot: "label",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("pc_kng_mark_lbl_key" /** 关键点 */)) +
                      "\n      "
                  ),
                  _c(
                    "yxt-popover",
                    {
                      attrs: {
                        trigger: "hover",
                        placement: "right-start",
                        offset: -10,
                        "max-width": "317",
                      },
                    },
                    [
                      _c(
                        "span",
                        [
                          _c("div", { staticClass: "yxt-weight-5" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_lbl_pointsintro" /** 关键点介绍 */
                                )
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "color-gray-9 mt5" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_lbl_pointsdesc" /** 根据内容提炼主题，设置关键点，方便学员学习。 */
                                )
                              )
                            ),
                          ]),
                          _c("yxt-image", {
                            staticClass: "mt12",
                            attrs: { src: _vm.pointImageUrl, fit: "cover" },
                          }),
                        ],
                        1
                      ),
                      _c("yxt-svg", {
                        staticClass: "color-gray-6 v-mid ml4 hover-primary-6",
                        attrs: {
                          slot: "reference",
                          width: "16px",
                          height: "16px",
                          "icon-class": "icons/question-cirlce-o",
                        },
                        slot: "reference",
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("form-point", {
                attrs: {
                  points: _vm.info.keyPoints,
                  "kng-id": _vm.info.id,
                  fileId: _vm.info.fileId,
                  showAiPoints:
                    !_vm.isHideAISubtitles &&
                    !_vm.info.serverGroupId &&
                    !_vm.info.distributeSourceType,
                  disabled: _vm.getItemDisabled("point"),
                },
                on: {
                  "update:points": function ($event) {
                    return _vm.$set(_vm.info, "keyPoints", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("coverUrl")
        ? _c(
            "yxt-form-item",
            { attrs: { label: _vm.$t("pc_biz_lbl_cover" /**封面 */) } },
            [
              _c("form-cover", {
                attrs: {
                  type: _vm.info.photoType,
                  coverUrl: _vm.info.coverUrl,
                },
                on: {
                  "update:type": function ($event) {
                    return _vm.$set(_vm.info, "photoType", $event)
                  },
                  "update:coverUrl": function ($event) {
                    return _vm.$set(_vm.info, "coverUrl", $event)
                  },
                  "update:cover-url": function ($event) {
                    return _vm.$set(_vm.info, "coverUrl", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.TIME)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "pc_biz_kng_lbl_standardduration" /** 标准时长 */
                ),
                prop: "studyHours",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.TIME),
              },
            },
            [
              _c("form-time", {
                attrs: {
                  disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.TIME),
                },
                on: { change: _vm.changeStudyHours },
                model: {
                  value: _vm.info.studyHours,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "studyHours", $$v)
                  },
                  expression: "info.studyHours",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.SCORE)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_studyScore" /**学分 */),
                prop: "studyScore",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.SCORE),
              },
            },
            [
              _c(
                "yxtbiz-language-slot",
                { attrs: { "lang-key": "pc_biz_kng_msg_studyscore" } },
                [
                  _vm.info.type === _vm.KNG_TYPE.COURSE
                    ? _c("span", { attrs: { slot: "0" }, slot: "0" }, [
                        _vm._v(_vm._s(_vm.info.studyScore)),
                      ])
                    : _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            slot: "0",
                            disabled: _vm.canEditCredits,
                            content: _vm.$t(
                              "pc_biz_lbl_noeditauth" /** 无编辑权限 */
                            ),
                          },
                          slot: "0",
                        },
                        [
                          _c("yxt-input-number", {
                            staticClass: "mr4",
                            attrs: {
                              precision: 2,
                              step: 1,
                              max: 9999.99,
                              min: 0,
                              disabled:
                                _vm.getItemDisabled(
                                  _vm.COURSE_ATTRIBUTE.SCORE
                                ) || !_vm.canEditCredits,
                            },
                            model: {
                              value: _vm.info.studyScore,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "studyScore", $$v)
                              },
                              expression: "info.studyScore",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.UNIQUE_CODE)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("kng_lbl_unique_code" /** 平台课程编号*/),
                prop: "uniqueCode",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.UNIQUE_CODE),
              },
            },
            [
              _c("yxt-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.info.uniqueCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "uniqueCode", $$v)
                  },
                  expression: "info.uniqueCode",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.CUSTOM_CODE)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("kng_lbl_custom_code" /**自定义课程编号 */),
                prop: "customCOde",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.CUSTOM_CODE),
              },
            },
            [_c("form-custom-code")],
            1
          )
        : _vm._e(),
      _vm.info.distributeSourceType
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_zoCode" /**商城课编号 */),
                prop: "zoCode",
              },
            },
            [
              _c("yxt-input", {
                attrs: { disabled: "", value: _vm.info.zoCode || "--" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.VALID_DATE)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_coursevalidtime" /** 有效期 */),
                prop: "expiredTime",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.VALID_DATE),
              },
            },
            [
              _c(
                "div",
                [
                  _c("yxt-date-picker", {
                    attrs: {
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      disabled: _vm.getItemDisabled(
                        _vm.COURSE_ATTRIBUTE.VALID_DATE
                      ),
                      placeholder: _vm.$t(
                        "pc_biz_rule_select_date" /** 选择日期 */
                      ),
                    },
                    model: {
                      value: _vm.info.expiredTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.info, "expiredTime", $$v)
                      },
                      expression: "info.expiredTime",
                    },
                  }),
                  _c("span", { staticClass: "ml8 color-gray-6" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_kng_upload_lbl_expire_tip" /** 超过有效期后，学员无法学习该课程 */
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
              !_vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.VALID_DATE)
                ? _c(
                    "div",
                    { staticClass: "yxtbiz-flex-center mt12" },
                    [
                      _c("yxt-checkbox", {
                        attrs: { "true-label": 1, "false-label": 0 },
                        model: {
                          value: _vm.info.expireNotice,
                          callback: function ($$v) {
                            _vm.$set(_vm.info, "expireNotice", $$v)
                          },
                          expression: "info.expireNotice",
                        },
                      }),
                      _c(
                        "yxtbiz-language-slot",
                        {
                          attrs: {
                            className: "ml8",
                            langKey: "pc_kng_upload_lbl_expire_notice",
                          },
                        },
                        [
                          _c("yxt-input-number", {
                            staticClass: "w104 ml8 mr8",
                            attrs: {
                              slot: "0",
                              min: 0,
                              precision: 0,
                              disabled: !_vm.info.expireNotice,
                            },
                            slot: "0",
                            model: {
                              value: _vm.info.expireDay,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "expireDay", $$v)
                              },
                              expression: "info.expireDay",
                            },
                          }),
                          _c("yxt-input-number", {
                            staticClass: "w104 ml8 mr8",
                            attrs: {
                              slot: "1",
                              min: 0,
                              max: 23,
                              precision: 0,
                              step: 1,
                              disabled: !_vm.info.expireNotice,
                            },
                            slot: "1",
                            model: {
                              value: _vm.info.expireHours,
                              callback: function ($$v) {
                                _vm.$set(_vm.info, "expireHours", $$v)
                              },
                              expression: "info.expireHours",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.isEdit && _vm.info.type === _vm.KNG_TYPE.HTML && !_vm.info.specialMode
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                prop: "indexPath",
                label: _vm.$t("pc_kng_kngcourse_lbl_setindex" /** 设置首页 */),
                rules: _vm.getItemRules("indexPath"),
              },
            },
            [
              _c("form-index", {
                attrs: {
                  content: _vm.info.courseChapterContent,
                  disabled: _vm.getItemDisabled("indexPath"),
                },
                model: {
                  value: _vm.info.indexPath,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "indexPath", $$v)
                  },
                  expression: "info.indexPath",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.PRICE)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_common_lbl_price" /** 价格 */),
                prop: "price",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.PRICE),
              },
            },
            [
              _c(
                "yxtbiz-language-slot",
                { attrs: { "lang-key": "pc_biz_lbl_credits" } },
                [
                  _c("yxt-input-number", {
                    staticClass: "mr4",
                    attrs: {
                      slot: "0",
                      precision: 0,
                      step: 1,
                      max: 9999,
                      min: 0,
                      disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.PRICE),
                    },
                    slot: "0",
                    model: {
                      value: _vm.info.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.info, "price", $$v)
                      },
                      expression: "info.price",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "color-gray-6",
                      attrs: { slot: "1" },
                      slot: "1",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "pc_kng_upload_msg_point" /**（设置积分后，学员需要使用相应的积分兑换后方可学习） */
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("completeStandard")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "pc_biz_kng_lbl_class_completion_standard" /**完课标准 */
                ),
              },
            },
            [
              _c("form-complete-standard", {
                ref: "standard",
                attrs: {
                  contentCompleteStandard: _vm.info.contentCompleteStandard,
                  timeCompleteStandard: _vm.info.timeCompleteStandard,
                  disabled: _vm.getItemDisabled("completeStandard"),
                },
                on: {
                  "update:contentCompleteStandard": function ($event) {
                    return _vm.$set(_vm.info, "contentCompleteStandard", $event)
                  },
                  "update:content-complete-standard": function ($event) {
                    return _vm.$set(_vm.info, "contentCompleteStandard", $event)
                  },
                  "update:timeCompleteStandard": function ($event) {
                    return _vm.$set(_vm.info, "timeCompleteStandard", $event)
                  },
                  "update:time-complete-standard": function ($event) {
                    return _vm.$set(_vm.info, "timeCompleteStandard", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.CONTENT_TAG)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_contentlabel" /**内容标签 */),
                prop: "contentTags",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.CONTENT_TAG),
              },
            },
            [
              _c("form-content-tag", {
                attrs: {
                  disabled: _vm.getItemDisabled(
                    _vm.COURSE_ATTRIBUTE.CONTENT_TAG
                  ),
                },
                on: {
                  change: function ($event) {
                    return _vm.$refs.form.validateField("contentTags")
                  },
                },
                model: {
                  value: _vm.info.contentTags,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "contentTags", $$v)
                  },
                  expression: "info.contentTags",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.SKILL_TAG)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                prop: "skillTags",
                label: _vm.$t("pc_biz_kng_lbl_abilitylabel" /**能力标签 */),
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.SKILL_TAG),
              },
            },
            [
              _c("form-skill-tag", {
                attrs: {
                  disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.SKILL_TAG),
                },
                on: {
                  change: function ($event) {
                    return _vm.$refs.form.validateField("skillTags")
                  },
                },
                model: {
                  value: _vm.info.skillTags,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "skillTags", $$v)
                  },
                  expression: "info.skillTags",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("displayMode")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_kng_kng_lbl_displaymode" /**展示模式 */),
              },
            },
            [
              _c("form-display-mode", {
                attrs: {
                  size: _vm.info.fontSize,
                  "show-size": _vm.getItemShow("fontSize"),
                  "show-size-limit": _vm.getItemShow("fontSizeLimit"),
                  disabled: _vm.getItemDisabled("displayMode"),
                },
                on: {
                  "update:size": function ($event) {
                    return _vm.$set(_vm.info, "fontSize", $event)
                  },
                },
                model: {
                  value: _vm.info.displayMode,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "displayMode", $$v)
                  },
                  expression: "info.displayMode",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("dataType")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_datatype" /**资料类型 */),
              },
            },
            [
              _c(
                "yxt-select",
                {
                  staticClass: "width-percent-100-i",
                  attrs: {
                    clearable: "",
                    disabled: _vm.getItemDisabled("dataType"),
                  },
                  model: {
                    value: _vm.info.studyMaterialType,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "studyMaterialType", $$v)
                    },
                    expression: "info.studyMaterialType",
                  },
                },
                [
                  _c("yxt-option", {
                    attrs: {
                      value: 1,
                      label: _vm.$t("kng_tag_lbl_display_type1"),
                    },
                  }),
                  _c("yxt-option", {
                    attrs: {
                      value: 2,
                      label: _vm.$t("kng_tag_lbl_display_type2"),
                    },
                  }),
                  _c("yxt-option", {
                    attrs: {
                      value: 3,
                      label: _vm.$t("kng_tag_lbl_display_type3"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "color-gray-6 lh24 mt8" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "kng_tag_lbl_display_type_desc" /** 课件/课程加入学习项目后会作为学习资料，有单独的入口展示 */
                        )
                      ) +
                      "\n      "
                  ),
                  _c(
                    "yxt-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.view(0)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("pc_kng_doc_support_html_lbl_demo")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.DESCRIBE)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                prop: "description",
                label: _vm.$t("pc_biz_kng_detail_lbl_introduction" /**简介 */),
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.DESCRIBE),
              },
            },
            [
              _c("form-desc", {
                attrs: {
                  htmlDesc: _vm.info.description,
                  disabled: _vm.getItemDisabled("COURSE_ATTRIBUTE.DESCRIBE"),
                },
                on: {
                  "update:htmlDesc": function ($event) {
                    return _vm.$set(_vm.info, "description", $event)
                  },
                  "update:html-desc": function ($event) {
                    return _vm.$set(_vm.info, "description", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.ATTACHMENT)
        ? _c(
            "yxt-form-item",
            {
              attrs: { label: _vm.$t("pc_biz_kng_lbl_attachment" /**附件 */) },
            },
            [
              _c("form-attachment", {
                ref: "attachmentForm",
                attrs: {
                  list: _vm.info.kngAttachSimpleBeans,
                  disabled: _vm.getItemDisabled(
                    _vm.COURSE_ATTRIBUTE.ATTACHMENT
                  ),
                },
                on: {
                  "update:list": function ($event) {
                    return _vm.$set(_vm.info, "kngAttachSimpleBeans", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.baseAttrs, function (item) {
        return _c(
          "yxt-form-item",
          {
            key: item.attrId,
            attrs: {
              label: item.attrName,
              prop: item.attrId,
              rules: _vm.getItemRules(
                _vm.COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE,
                item
              ),
            },
          },
          [
            _c("form-base-custom", {
              attrs: {
                attr: item,
                info: _vm.info,
                disabled: _vm.getItemDisabled(
                  _vm.COURSE_ATTRIBUTE.CUSTOM_ATTRIBUTE
                ),
              },
            }),
          ],
          1
        )
      }),
      _vm.getItemShow("supplier")
        ? _c(
            "yxt-form-item",
            { attrs: { label: _vm.$t("pc_kng_kngcourse_lbl_supplier") } },
            [
              _c("yxtbiz-supplier-select", {
                attrs: {
                  width: "100%",
                  selectData: _vm.info.supplierId
                    ? {
                        supplierCreditCode: _vm.info.supplierId,
                        supplierName: _vm.info.supplierName,
                      }
                    : {},
                },
                on: { getSelected: _vm.didSelectSupplier },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "yxtbiz-kng-operator__form-title mt32",
          attrs: { id: "info_2" },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("pc_biz_kng_lbl_reletedinfo" /**相关方信息 */)) +
              "\n  "
          ),
        ]
      ),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.CONTRIBUTOR)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.getAttrConfig(_vm.COURSE_ATTRIBUTE.CONTRIBUTOR)
                  .attrName,
                prop: "contributorsUser",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.CONTRIBUTOR),
              },
            },
            [
              _c("form-related", {
                attrs: {
                  name: _vm.info.contributorsName,
                  id: _vm.info.contributorsUser,
                  disabled: _vm.getItemDisabled(
                    _vm.COURSE_ATTRIBUTE.CONTRIBUTOR
                  ),
                },
                on: {
                  "update:name": function ($event) {
                    return _vm.$set(_vm.info, "contributorsName", $event)
                  },
                  "update:id": function ($event) {
                    return _vm.$set(_vm.info, "contributorsUser", $event)
                  },
                },
              }),
              _vm.config.openReward
                ? _c(
                    "yxt-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": 0,
                        disabled: _vm.getItemDisabled(
                          _vm.COURSE_ATTRIBUTE.CONTRIBUTOR
                        ),
                      },
                      model: {
                        value: _vm.info.rewardFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.info, "rewardFlag", $$v)
                        },
                        expression: "info.rewardFlag",
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "pc_kng_upload_lbl_allow_reward" /** 允许学员打赏 */
                            )
                          ) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.AUTHOR)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.getAttrConfig(_vm.COURSE_ATTRIBUTE.AUTHOR).attrName,
                prop: "author",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.AUTHOR),
              },
            },
            [
              _c("form-related", {
                attrs: {
                  name: _vm.info.author,
                  id: _vm.info.authorId,
                  attrId: _vm.getAttrConfig(_vm.COURSE_ATTRIBUTE.AUTHOR).id,
                  disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.AUTHOR),
                },
                on: {
                  "update:name": function ($event) {
                    return _vm.$set(_vm.info, "author", $event)
                  },
                  "update:id": function ($event) {
                    return _vm.$set(_vm.info, "authorId", $event)
                  },
                },
              }),
              _c(
                "yxt-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.AUTHOR),
                  },
                  on: { change: _vm.changeOriginal },
                  model: {
                    value: _vm.info.originality,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "originality", $$v)
                    },
                    expression: "info.originality",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_originaltag" /**原创 */)) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.LECTURER)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.getAttrConfig(_vm.COURSE_ATTRIBUTE.LECTURER)
                  .attrName,
                prop: "lecturesName",
                rules: _vm.getItemRules(_vm.COURSE_ATTRIBUTE.LECTURER),
              },
            },
            [
              _c("form-related", {
                attrs: {
                  name: _vm.info.lecturesName,
                  id: _vm.info.lecturesId,
                  attrId: _vm.getAttrConfig(_vm.COURSE_ATTRIBUTE.LECTURER).id,
                  dataPermissionCode: "Courselecturer_extent",
                  disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.LECTURER),
                },
                on: {
                  "update:name": function ($event) {
                    return _vm.$set(_vm.info, "lecturesName", $event)
                  },
                  "update:id": function ($event) {
                    return _vm.$set(_vm.info, "lecturesId", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow(_vm.COURSE_ATTRIBUTE.ASSISTANT_LECTURER)
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.getAttrConfig(
                  _vm.COURSE_ATTRIBUTE.ASSISTANT_LECTURER
                ).attrName,
                prop: "counseLorteacherNames",
                rules: _vm.getItemRules(
                  _vm.COURSE_ATTRIBUTE.ASSISTANT_LECTURER
                ),
              },
            },
            [
              _c("form-related", {
                attrs: {
                  name: _vm.info.counseLorteacherNames,
                  id: _vm.info.counseLorteacherIds,
                  attrId: _vm.getAttrConfig(
                    _vm.COURSE_ATTRIBUTE.ASSISTANT_LECTURER
                  ).id,
                  dataPermissionCode: "CourseAssistantlecturer_extent",
                  disabled: _vm.getItemDisabled(_vm.COURSE_ATTRIBUTE.LECTURER),
                },
                on: {
                  "update:name": function ($event) {
                    return _vm.$set(_vm.info, "counseLorteacherNames", $event)
                  },
                  "update:id": function ($event) {
                    return _vm.$set(_vm.info, "counseLorteacherIds", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.relatedAttrs, function (item) {
        return _c(
          "yxt-form-item",
          {
            key: item.attrId,
            attrs: {
              label: item.attrName,
              prop: item.attrId,
              rules: _vm.getItemRules(
                _vm.COURSE_ATTRIBUTE.CUSTOM_RELATED,
                item
              ),
            },
          },
          [
            _c("form-related", {
              attrs: {
                isCustom: "",
                name: item.userName,
                id: item.value,
                attrId: item.attrId,
                disabled: _vm.getItemDisabled(
                  _vm.COURSE_ATTRIBUTE.CUSTOM_RELATED
                ),
              },
              on: {
                "update:name": function ($event) {
                  return _vm.$set(item, "userName", $event)
                },
                "update:id": function ($event) {
                  return _vm.$set(item, "value", $event)
                },
              },
            }),
          ],
          1
        )
      }),
      _c(
        "div",
        {
          staticClass: "yxtbiz-kng-operator__form-title mt32",
          attrs: { id: "info_3" },
        },
        [_vm._v(_vm._s(_vm.$t("pc_biz_kng_lbl_authsetting" /**权限设置 */)))]
      ),
      _c(
        "yxt-form-item",
        { attrs: { label: _vm.$t("pc_biz_kng_lbl_ishide" /**是否隐藏 */) } },
        [
          _c(
            "yxt-checkbox",
            {
              attrs: {
                "true-label": 0,
                "false-label": 1,
                disabled: _vm.getItemDisabled("visiable"),
              },
              model: {
                value: _vm.info.visiable,
                callback: function ($$v) {
                  _vm.$set(_vm.info, "visiable", $$v)
                },
                expression: "info.visiable",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "pc_kng_upload_msg_auth_text1" /**设为隐藏状态（仅在课程或项目中使用） */
                    )
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "yxt-form-item",
        {
          attrs: { label: _vm.$t("pc_biz_kng_lbl_shareauth" /** 分享权限 */) },
        },
        [
          _c(
            "yxt-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.getItemDisabled("share"),
              },
              model: {
                value: _vm.info.shareEnabled,
                callback: function ($$v) {
                  _vm.$set(_vm.info, "shareEnabled", $$v)
                },
                expression: "info.shareEnabled",
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("pc_biz_kng_lbl_allowshare" /**允许Ta人分享 */)
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm.getItemShow("appEnabled")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("kng_biz_lbl_mobile_view" /** 手机观看 */),
              },
            },
            [
              _c(
                "yxt-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.getItemDisabled("appEnabled"),
                  },
                  model: {
                    value: _vm.info.appEnabled,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "appEnabled", $$v)
                    },
                    expression: "info.appEnabled",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "kng_biz_lbl_mobile_view_tip1" /** 支持手机观看（课程需要适配移动端，否则会导致学员使用手机学习时出现异常） */
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "yxt-form-item",
        {
          staticClass: "error-ml24",
          attrs: {
            label: _vm.$t("pc_biz_kng_lbl_viewauth" /**浏览权限 */),
            prop: "permissionType",
            rules: _vm.getItemRules("browser"),
          },
        },
        [
          _c("form-browse-auth", {
            attrs: {
              permissions: _vm.info.browsePermissions,
              isCourse: _vm.info.type === _vm.KNG_TYPE.COURSE,
              disabled: _vm.getItemDisabled("browser"),
            },
            on: {
              "update:permissions": function ($event) {
                return _vm.$set(_vm.info, "browsePermissions", $event)
              },
            },
            model: {
              value: _vm.info.permissionType,
              callback: function ($$v) {
                _vm.$set(_vm.info, "permissionType", $$v)
              },
              expression: "info.permissionType",
            },
          }),
        ],
        1
      ),
      _vm.getItemShow("download")
        ? _c(
            "yxt-form-item",
            {
              staticClass: "error-ml24",
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_pcdownauth" /**下载权限 */),
                prop: "downEnabled",
                rules: _vm.getItemRules("download"),
              },
            },
            [
              _c("form-download-auth", {
                attrs: {
                  allowDownload: _vm.info.allowDown,
                  permissions: _vm.info.downloadPermissions,
                  disabled: _vm.getItemDisabled("download"),
                },
                on: {
                  "update:allowDownload": function ($event) {
                    return _vm.$set(_vm.info, "allowDown", $event)
                  },
                  "update:allow-download": function ($event) {
                    return _vm.$set(_vm.info, "allowDown", $event)
                  },
                  "update:permissions": function ($event) {
                    return _vm.$set(_vm.info, "downloadPermissions", $event)
                  },
                },
                model: {
                  value: _vm.info.downEnabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "downEnabled", $$v)
                  },
                  expression: "info.downEnabled",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("download_source")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "pc_kng_upload_label_down_filetype_title" /**下载文件 */
                ),
              },
            },
            [
              _c("form-download-source", {
                attrs: {
                  batchSetting: _vm.batchSetting,
                  disabled: _vm.getItemDisabled("download_source"),
                },
                model: {
                  value: _vm.info.downloadType,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "downloadType", $$v)
                  },
                  expression: "info.downloadType",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("appCache")
        ? _c(
            "yxt-form-item",
            {
              staticClass: "error-ml24",
              attrs: {
                label: _vm.$t(
                  "pc_biz_kng_lbl_appcacheauth" /**App缓存课件权限 */
                ),
                prop: "appDownEnabled",
                rules: _vm.getItemRules("appCache"),
              },
            },
            [
              _c("form-app-cache-auth", {
                attrs: {
                  allowDownload: _vm.info.allowAppDown,
                  permissions: _vm.info.appDownloadPermissions,
                  disabled: _vm.getItemDisabled("appCache"),
                },
                on: {
                  "update:allowDownload": function ($event) {
                    return _vm.$set(_vm.info, "allowAppDown", $event)
                  },
                  "update:allow-download": function ($event) {
                    return _vm.$set(_vm.info, "allowAppDown", $event)
                  },
                  "update:permissions": function ($event) {
                    return _vm.$set(_vm.info, "appDownloadPermissions", $event)
                  },
                },
                model: {
                  value: _vm.info.appDownEnabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.info, "appDownEnabled", $$v)
                  },
                  expression: "info.appDownEnabled",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("visitor")
        ? _c(
            "yxt-form-item",
            {
              staticClass: "error-ml24",
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_visitorstudy" /**游客访问 */),
                prop: "visitorConfDTO",
                rules: _vm.getItemRules("visitor"),
              },
            },
            [
              _c("form-visitor", {
                attrs: {
                  config: _vm.info.visitorConfDTO,
                  disabled: _vm.getItemDisabled("visitor"),
                },
                on: {
                  "update:config": function ($event) {
                    return _vm.$set(_vm.info, "visitorConfDTO", $event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "yxtbiz-kng-operator__form-title mt32",
          attrs: { id: "info_4" },
        },
        [_vm._v(_vm._s(_vm.$t("pc_biz_kng_lbl_funsetting" /**功能设置 */)))]
      ),
      _vm.getItemShow("autoUpgrade")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "pc_kng_upload_lbl_newweike_autoupdate" /**自动更新 */
                ),
              },
            },
            [
              _c(
                "yxt-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.getItemDisabled("autoUpgrade"),
                  },
                  model: {
                    value: _vm.info.autoUpgrade,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "autoUpgrade", $$v)
                    },
                    expression: "info.autoUpgrade",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "pc_kng_upload_lbl_newweike_autoupdate_text1" /**开启课件自动更新 */
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _c(
                "yxt-tooltip",
                {
                  attrs: {
                    "max-width": "400",
                    effect: "dark",
                    placement: "bottom",
                    content: _vm.$t(
                      "pc_kng_upload_lbl_newweike_autoupdate_text1_tip" /* 开启后，微课更新时课件内容会自动更新到新版 */
                    ),
                  },
                },
                [
                  _c("yxt-svg", {
                    staticClass: "hand v-mid color-gray-6",
                    attrs: {
                      width: "16px",
                      height: "16px",
                      "icon-class": "icons/question-cirlce-o",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "yxt-form-item",
        {
          attrs: {
            label: _vm.$t("pc_biz_kng_lbl_completecomment" /**完课评论 */),
          },
        },
        [
          _c(
            "yxt-checkbox",
            {
              attrs: {
                "true-label": 1,
                "false-label": 0,
                disabled: _vm.getItemDisabled("completeComment"),
              },
              model: {
                value: _vm.info.enableStudyedAlert,
                callback: function ($$v) {
                  _vm.$set(_vm.info, "enableStudyedAlert", $$v)
                },
                expression: "info.enableStudyedAlert",
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "pc_biz_kng_lbl_opencompletecomment" /** 开启完课评论弹窗 */
                  )
                ) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm.getItemShow("bbs")
        ? _c(
            "yxt-form-item",
            {
              attrs: { label: _vm.$t("pc_biz_kng_bbscommunity" /**讨论区 */) },
            },
            [
              _c(
                "yxt-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.getItemDisabled("bbs"),
                  },
                  model: {
                    value: _vm.info.enableBbs,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "enableBbs", $$v)
                    },
                    expression: "info.enableBbs",
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_kng_lbl_openbbs" /** 开启讨论区 */)) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("note")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_note" /**笔记区 */),
                "label-tooltip": _vm.$t("pc_kng_courseware_tip_noteArea"),
              },
            },
            [
              _c(
                "yxt-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.getItemDisabled("note"),
                  },
                  model: {
                    value: _vm.info.enableNote,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "enableNote", $$v)
                    },
                    expression: "info.enableNote",
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_kng_lbl_openbote" /** 开启公开笔记区 */)
                    ) + "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("watermark")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_watercontrol" /**水印控制 */),
              },
            },
            [
              _c(
                "yxt-radio-group",
                {
                  attrs: {
                    direction: "row",
                    disabled: _vm.getItemDisabled("watermark"),
                  },
                  model: {
                    value: _vm.info.watermarkFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "watermarkFlag", $$v)
                    },
                    expression: "info.watermarkFlag",
                  },
                },
                [
                  _c("yxt-radio", { attrs: { label: 0 } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "pc_kng_watermark_control_follow" /**跟随平台设置（我的企业-安全中心-数据安全-水印控制） */
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _c("yxt-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_kng_watermark_control_close" /**不开启水印 */
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("multiShow")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_speedplay" /**倍速播放 */),
                "label-tooltip":
                  _vm.info.type === _vm.KNG_TYPE.COURSE
                    ? _vm.$t("pc_kng_lbl_study_rate_tips")
                    : "",
              },
            },
            [
              _vm.multiConfig.multipleMode === 1
                ? _c("div", [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "pc_kng_lbl_Speed_tip1" /**已开启倍速播放（学员可以切换1.25/1.5/1.75/2倍速播放） */
                          )
                        ) +
                        "\n    "
                    ),
                  ])
                : _c(
                    "yxt-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": 0,
                        disabled: _vm.getItemDisabled("multiShow"),
                      },
                      model: {
                        value: _vm.info.enableMultipleSwitch,
                        callback: function ($$v) {
                          _vm.$set(_vm.info, "enableMultipleSwitch", $$v)
                        },
                        expression: "info.enableMultipleSwitch",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_kng_lbl_openSpeed" /** 开启倍速播放（开启后，学员可以切换1.25/1.5/1.75/2倍速播放）*/
                          )
                        ) + "\n    "
                      ),
                    ]
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("multiShow") &&
      (_vm.info.enableMultipleSwitch || _vm.multiConfig.multipleMode === 1)
        ? _c(
            "yxt-form-item",
            {
              attrs: { label: _vm.$t("pc_kng_lbl_hours_calc" /**学时计算 */) },
            },
            [
              _vm.multiConfig.multipleMode === 1
                ? _c("div", [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.multiConfig.multipleStudy === 1
                            ? _vm.$t(
                                "pc_kng_lbl_Speed_tip3" /**倍速播放时学习时长也倍速计算（举例：学员2倍速学习5分钟，学习时长算10分钟） */
                              )
                            : _vm.$t(
                                "pc_kng_lbl_Speed_tip4" /**倍速播放时学习时长不会倍速计算（举例：学员2倍速学习5分钟，学习时长算5分钟） */
                              )
                        ) +
                        "\n    "
                    ),
                  ])
                : _c(
                    "yxt-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": 0,
                        disabled: _vm.getItemDisabled("multiShow"),
                      },
                      model: {
                        value: _vm.info.enableMultiple,
                        callback: function ($$v) {
                          _vm.$set(_vm.info, "enableMultiple", $$v)
                        },
                        expression: "info.enableMultiple",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_kng_lbl_multipleStudy3" /** 倍速播放时学习时长也倍速计算（举例：学员2倍速学习5分钟，学习时长计算10分钟） */
                          )
                        ) + "\n    "
                      ),
                    ]
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("drag")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_kng_lbl_dragstudy" /**拖拽学习 */),
                "label-tooltip":
                  _vm.info.type === _vm.KNG_TYPE.COURSE
                    ? _vm.$t("pc_kng_lbl_study_tips")
                    : "",
              },
            },
            [
              _c(
                "yxt-checkbox",
                {
                  attrs: {
                    "true-label": 1,
                    "false-label": 0,
                    disabled: _vm.getItemDisabled("drag"),
                  },
                  model: {
                    value: _vm.info.enableDrag,
                    callback: function ($$v) {
                      _vm.$set(_vm.info, "enableDrag", $$v)
                    },
                    expression: "info.enableDrag",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "pc_biz_kng_lbl_opendragstudy" /** 支持拖拽学习 */
                        )
                      ) +
                      "\n      "
                  ),
                  !_vm.info.enableDrag
                    ? _c("span", { staticClass: "color-gray-6" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "pc_kng_lbl_dragStudy_tips" /**（仅限制未完课的学员拖拽） */
                            )
                          )
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("face")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_lbl_appface" /**人脸识别（仅APP支持） */),
              },
            },
            [
              _vm.faceConfig.useScope === 0
                ? _c("form-face", {
                    ref: "faceForm",
                    attrs: { config: _vm.faceConfig, disabled: "" },
                    on: {
                      "update:config": function ($event) {
                        _vm.faceConfig = $event
                      },
                    },
                  })
                : _c("form-face", {
                    ref: "faceForm",
                    attrs: {
                      disabled: _vm.getItemDisabled("face"),
                      config: _vm.info.faceRecognitionConfig,
                    },
                    on: {
                      "update:config": function ($event) {
                        return _vm.$set(
                          _vm.info,
                          "faceRecognitionConfig",
                          $event
                        )
                      },
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
      _vm.getItemShow("AI")
        ? _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_kng_lbl_ai_subtitles" /**AI字幕 */),
                prop: "subtitlesFlag",
                rules: _vm.getItemRules("AI"),
              },
            },
            [
              _c(
                "yxt-tooltip",
                {
                  attrs: {
                    disabled: !!_vm.info.subtitlesStatus || _vm.config.canUseAI,
                    content: _vm.$t(
                      "pc_kng_lbl_ai_account_balance" /**账户余额不足，充值后才能使用 */
                    ),
                  },
                },
                [
                  _c(
                    "yxt-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": 0,
                        disabled: _vm.getItemDisabled("AI"),
                      },
                      model: {
                        value: _vm.info.subtitlesFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.info, "subtitlesFlag", $$v)
                        },
                        expression: "info.subtitlesFlag",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "pc_kng_lbl_ai_subtitles_open" /** 开启AI字幕（开启后，该课件会生成字幕文稿，如您的音视频中自带字幕，请关闭该功能，避免字幕冲突） */
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.info.subtitlesFlag
                ? _c(
                    "yxt-checkbox",
                    {
                      attrs: {
                        "true-label": 1,
                        "false-label": 0,
                        disabled: _vm.getItemDisabled("AI"),
                      },
                      model: {
                        value: _vm.info.syncMark,
                        callback: function ($$v) {
                          _vm.$set(_vm.info, "syncMark", $$v)
                        },
                        expression: "info.syncMark",
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t(
                              "pc_kng_lbl_ai_sync_mark" /** 同步生成关键点标记（根据内容自动提炼主题，生成关键点） */
                            )
                          )
                      ),
                      _c(
                        "yxt-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.view(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pc_kng_doc_support_html_lbl_demo" /** 查看示例 */
                              )
                            )
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.url
        ? _c("yxtbiz-image-viewer", {
            ref: "viewer",
            attrs: {
              "no-list": "",
              showNavbar: false,
              showToolbar: false,
              data: [{ url: _vm.url }],
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }